module.exports = __webpack_public_path__ + "img/Ranzen.2a8a3dbb.jpg";